import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Redirect component for /login in immersive theme
 * Redirects to homepage with login tab active
 */
export default function ImmersiveLoginRedirect() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Redirect to homepage with login tab active
    navigate('/', { 
      state: { 
        tab: 'auth',
        from: location.state?.from // Preserve original redirect target
      },
      replace: true 
    })
  }, [navigate, location])

  return null
}
